import fs from 'node:fs'
import os from 'node:os'
import path from 'node:path'
import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { ENV_PULL_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { runVercel } from './runner/run-vercel.js'
/** `vercel env pull` overwrites `.env.local` unless given an explicit target file. */
export async function pullVercelEnvValue<T>(
  runner: VercelRunner,
  cwd: string,
  read: (filePath: string) => T | undefined,
  env?: NodeJS.ProcessEnv,
  environment: 'development' | 'preview' | 'production' = 'development'
): Promise<T | undefined> {
  const tmpDir = fs.mkdtempSync(path.join(os.tmpdir(), 'betterstart-vercel-'))
  const tmpEnv = path.join(tmpDir, '.env.pull')

  try {
    const pull = await runVercel(
      runner,
      ['env', 'pull', tmpEnv, '--environment', environment, '--yes'],
      { cwd, mode: 'capture', timeoutMs: ENV_PULL_TIMEOUT_MS, env }
    )
    if (!pull.success) return undefined
    return read(tmpEnv)
  } finally {
    try {
      fs.rmSync(tmpDir, { recursive: true, force: true })
    } catch {}
  }
}
